export const getUser = () => {
  return JSON.parse(localStorage.getItem("ml_user")) || {
    name: "Usuário",
    scores: {
      sequence: 0,
      visual: 0,
      delay: 0
    },
    badges: [],
    history: []
  };
};

export const saveUser = (user) => {
  localStorage.setItem("ml_user", JSON.stringify(user));

  // 🔥 DISPARA EVENTO GLOBAL
  window.dispatchEvent(new Event("ml_update"));
};

export const updateUserName = (name) => {
  const user = getUser();
  user.name = name;
  saveUser(user);
};

export const updateScore = (type, score) => {
  const user = getUser();

  if (score > user.scores[type]) {
    user.scores[type] = score;
    saveUser(user); // só salva se for record
  }
};